import React from 'react';
import './VisaServices.css';
import { useNavigate } from 'react-router-dom';

const visaServices = [
    {
        title: 'Tourist Visa',
        icon: 'fa-solid fa-passport',
        description: 'Effortless tourist visa processing for over 50+ countries with expert documentation support.',
        points: ['Documentation Assistance', 'Appointment Scheduling', 'Form Filling']
    },
    {
        title: 'Business Visa',
        icon: 'fa-solid fa-briefcase',
        description: 'Fast-track business visa services to ensure your corporate travels are smooth and punctual.',
        points: ['Invitation Letter Guidance', 'Priority Processing', 'Corporate Support']
    },
    {
        title: 'Domestic Flights',
        icon: 'fa-solid fa-plane-arrival',
        description: 'Get the best price guarantee on all major domestic airlines with instant ticketing.',
        points: ['Cheapest Fare Deals', 'Group Booking Discounts', '24/7 Support']
    },
    {
        title: 'International Flights',
        icon: 'fa-solid fa-plane-departure',
        description: 'Premium international flight booking with exclusive deals on top-tier global airlines.',
        points: ['World-class Carriers', 'Multi-city Itineraries', 'Meal & Seat Selection']
    }
];



const VisaServices = () => {
    const navigate = useNavigate();
    return (
        <section className="visa-section" id="visa">
            <div className="visa-container">
                <div className="visa-layout">
                    {/* Left Side: Dynamic Content */}
                    <div className="visa-content">
                        <span className="visa-label">Travel Essentials</span>
                        <h2 className="visa-title">Visa & Flight <span className="text-blue">Assistance</span></h2>
                        <p className="visa-description">
                            We provide seamless support for all your travel documentation and transport needs,
                            ensuring you get the best prices and expert visa handling.
                        </p>

                        <div className="visa-features">
                            <div className="v-feature">
                                <i className="fa-solid fa-circle-check"></i>
                                <div>
                                    <h4>99% Success Rate</h4>
                                    <p>Highest industry approval rates</p>
                                </div>
                            </div>
                            <div className="v-feature">
                                <i className="fa-solid fa-clock"></i>
                                <div>
                                    <h4>Fast Processing</h4>
                                    <p>Express turnaround times</p>
                                </div>
                            </div>
                        </div>

                        <button onClick={() => navigate('/contact')} className="visa-cta-btn">Check Requirements</button>
                    </div>

                    {/* Right Side: Service Cards */}
                    <div className="visa-grid">
                        {visaServices.map((service, index) => (
                            <div key={index} className="visa-card">
                                <div className="v-card-icon">
                                    <i className={service.icon}></i>
                                </div>
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                                <ul className="v-checklist">
                                    {service.points.map((pt, idx) => (
                                        <li key={idx}><i className="fa-solid fa-check"></i> {pt}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VisaServices;
